/*
 * @Author: zhangsheng
 * @Date: 2023-08-21 09:51:52
 * @LastEditors: zhangsheng
 * @LastEditTime: 2025-12-23 15:07:33
 * @FilePath: \panda-index-sicermem-frontend - 副本\src\pc\index.tsx
 * @Description:
 *
 * Copyright (c) 2023 by zhangsheng , All Rights Reserved.
 */
import React from 'react';
import { BrowserRouter as Router, useRoutes } from 'react-router-dom';

import pcRouter from './router';
import { useTranslation } from 'react-i18next';

const AppRoutes = () => useRoutes(pcRouter);
const App: React.FC = () => {
  const { i18n } = useTranslation();

  return (
    <Router>
      <AppRoutes />
    </Router>
  );
};
export default App;
